module.exports = __webpack_public_path__ + "static/media/img_qudao6@2x.a00ebc4b.png";